const notificationsSelectors = function() {
  const self = {};

  // NOTE: this is a private method to protect agains use out side of this
  // files scope
  // selects notifications out of the root state shape
  // state.notifications
  const _select = function(state) {
    return state.notifications;
  };

  // select the all of the notifications
  self.selectAll = function(state) {
    const root = _select(state);

    return root.notifications;
  };

  // select the unread count number, used to show user how many notifications
  // they have yet to see
  self.selectUnreadNotificationsCount = function(state) {
    const root = _select(state);

    return root.unreadCount;
  };

  // select the page number of the notifications list is on
  self.selectCurrentPage = function(state) {
    const root = _select(state);

    return root.currentPage;
  };

  return self;
};


export default notificationsSelectors();
